import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { FiSave, FiX } from 'react-icons/fi';
import Api from '../../Api';
import Helpers from '../../Helpers';
import Modal from '../Modal';
import Button from '../Button';
import Input from '../Input';
import Select from '../Select';
import MultiSelect from '../MultiSelect';
import '../CompanyForm/style.css';

export default function EmployeeBenefitsModal({
  isOpen,
  onClose,
  companyId,
  employee,
  onSuccess,
}) {
  const [loading, setLoading] = useState(false);
  const [benefits, setBenefits] = useState([]);
  const [formData, setFormData] = useState({
    has_family_benefit: 'false',
    dependents_count: '',
    benefit_ids: [],
  });

  useEffect(() => {
    if (isOpen && companyId) {
      loadBenefits();
    }
  }, [isOpen, companyId]);

  useEffect(() => {
    if (isOpen && employee) {
      setFormData({
        has_family_benefit: employee.has_family_benefit ? 'true' : 'false',
        dependents_count: employee.dependents_count || '',
        benefit_ids: employee.benefits
          ? employee.benefits.map((b) => String(b.id))
          : [],
      });
    }
  }, [isOpen, employee]);

  async function loadBenefits() {
    try {
      const data = await Api.getBenefits(companyId);

      const formattedBenefits = data.map(b => {
        const valueLabel =
          b.value != null
            ? Helpers.toBRL(b.value)
            : null;

        let frequencyLabel = '';
        if (b.frequency === 'daily') {
          frequencyLabel = 'DIÁRIO';
        } else if (b.frequency === 'monthly') {
          frequencyLabel = 'MENSAL';
        }

        const parts = [b.name];
        if (valueLabel) {
          if (frequencyLabel) {
            parts.push(`- ${valueLabel} (${frequencyLabel})`);
          } else {
            parts.push(`- ${valueLabel}`);
          }
        }

        return {
          value: b.id,
          label: parts.join(' '),
        };
      });

      setBenefits(formattedBenefits);
    } catch (error) {
      toast.error('Erro ao carregar benefícios.');
    }
  }

  function handleChange(e) {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);

    try {
      await Api.put(
        `/companies/${companyId}/employees/${employee.id}/benefits`,
        formData
      );
      toast.success('Benefícios atualizados com sucesso!');
      onSuccess();
      onClose();
    } catch (error) {
      const message =
        error.response?.data?.error || 'Erro ao atualizar benefícios.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Benefícios - ${employee?.name}`}
    >
      <form onSubmit={handleSubmit} className="company-form-component">
        <div className="form-body">
          <div className="form-grid">
            <div className="input-group full-width">
              <label>Benefícios</label>
              <MultiSelect
                options={benefits}
                value={formData.benefit_ids}
                onChange={(selected) =>
                  setFormData((prev) => ({ ...prev, benefit_ids: selected }))
                }
                placeholder="Selecione os benefícios"
              />
            </div>

            <Select
              id="has_family_benefit"
              label="Recebe Salário Família?"
              value={formData.has_family_benefit}
              onChange={handleChange}
              options={[
                { value: 'false', label: 'Não' },
                { value: 'true', label: 'Sim' }
              ]}
            />

            {formData.has_family_benefit === 'true' && (
              <Input
                id="dependents_count"
                label="Número de Dependentes"
                type="number"
                value={formData.dependents_count}
                onChange={handleChange}
                required
              />
            )}
          </div>
        </div>

        <div className="form-actions">
          <Button
            type="button"
            className="cancel-button"
            onClick={onClose}
            disabled={loading}
          >
            <FiX /> Cancelar
          </Button>
          <Button type="submit" disabled={loading}>
            <FiSave /> Salvar
          </Button>
        </div>
      </form>
    </Modal>
  );
}
